// Tala de turnos

import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
} from "@mui/material";
import { getShiftStatusLabel } from './ShiftStatus';

export default function ShiftsTable({ title, shifts, getSite, getTemplate }) {
  if (!shifts.length) return null;

  return (
    <Box sx={{ mb: 4, mt: 4 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        {title}
      </Typography>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead
            sx={{
              backgroundColor: '#f5f5f5',
              textTransform: 'uppercase',
            }}
          >
            <TableRow>
              <TableCell>Ubicación</TableCell>
              <TableCell>Fecha</TableCell>
              <TableCell>Turno</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {shifts.map((shift) => (
              <TableRow key={shift.id}>

                <TableCell sx={{ py: 1.5, px: 1 }}>
                  {getSite(shift.siteId)?.name || shift.siteId}
                </TableCell>

                <TableCell sx={{ py: 1.5, px: 1 }}>
                  {new Date(shift.shiftDate).toLocaleDateString()}
                </TableCell>
      
                <TableCell sx={{ py: 1.5, px: 1 }}>
                  {getTemplate(shift.shiftTemplateId)?.name || shift.shiftTemplateId}
                </TableCell>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}